import React from 'react';
import Logo from 'components/UI/Logo/Logo';
import Footers from 'components/Footer/Footer';
import FooterMenu from './FooterMenu';

const Footer = () => {
  return (
    <Footers
      logo={
        <Logo
          withLink
          linkTo="/"
          src="https://bid-your-stay.s3.ap-south-1.amazonaws.com/assets/images/logo/unpaqd_logo.svg"
          title="Unpaqd"
        />
      }
      menu={<FooterMenu />}
      copyright={`Copyright @ ${new Date().getFullYear()} Brokfree Travel Tech Pvt Ltd.`}
    />
  );
};

export default Footer;
